<section class="default-section-even homepage-section homepage-section--default px-md-4 px-3 py-5">
    <div class="container">
        <!-- <section class="row" *ngIf="imageDescription"> -->
        <section class="row">
            <article class="homepage-section__column col-xl-4 col-lg-5 col-12 order-lg-2">
                <div class="homepage-section__caption">
                    <fitscovery-ui-markdown-viewer [content]="imageDescription?.caption || ''" ></fitscovery-ui-markdown-viewer>
                </div>
                <div class="homepage-section__description">
                    <fitscovery-ui-markdown-viewer [content]="imageDescription?.description || ''" ></fitscovery-ui-markdown-viewer>
                </div>
                <div class="homepage-section__buttons">
                    <ng-container *ngFor="let button of imageDescription?.buttons">
                        <div class="d-flex" [ngClass]="setButtonAlignmentClass(button)">
                            <fitscovery-ui-custom-button class="mx-lg-0 mx-auto" [button]="button" [email]="partner?.contactInfo!.email" [homePageVersion]="partner?.appConfig!.homePageVer!"></fitscovery-ui-custom-button>
                        </div>
                    </ng-container>
                </div>
            </article>
            <article class="homepage-section__column col-xl-8 col-lg-7 col-12 d-flex order-lg-1">
                <div class="homepage-section__image pr-lg-4 pt-lg-0 pt-5">
                  <!-- <img
                    defaultImage="https://fitscovery-ng-cdn.s3.ap-southeast-1.amazonaws.com/default-image-white.webp" 
                    errorImage="https://fitscovery-ng-cdn.s3.ap-southeast-1.amazonaws.com/default-image-white.webp" 
                    [lazyLoad]="imageDescription.url"
                    class="img-fluid"> -->
                    <img class="img-fluid" [src]="imageDescription?.url">
                </div>
            </article>
        </section>
    </div>
</section>